/**
 * Created by piotr@revisual on 04/08/2025.
 */

import { useEffect, useRef } from "react";

/**
 * Interval hook that runs a callback function at specified intervals.
 * @param {function} callback - The function to be executed at each interval.
 * @param {number} delay - The interval delay in milliseconds.
 * @param {boolean} [immediate=false] - If true, the callback is executed immediately on mount.
 */

export const useInterval = (callback, delay, immediate = false) => {
  const savedCallback = useRef();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    if (immediate) {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(() => {
        savedCallback.current();
      }, delay);

      return () => clearInterval(id);
    }
  }, [delay, immediate]);
};

export default useInterval;
